import type { OrganisationRole } from "@bafe/types";

import { isLegacyUserAccountPath, isUserSettingsPath } from "./platform-navigation.js";

/** Default mail SPA entry when no workspace slug is known yet. */
export const WEBMAIL_HOME = "/mail/";

const ACCOUNT_SECTIONS = new Set(["profile", "security", "sessions", "data"]);

export function isMailOnlyOrganisationRole(role: OrganisationRole): boolean {
	return role === "user";
}

/** Personal account settings reachable from webmail; not workspace administration. */
export function isMailOnlyAccountPath(pathname: string): boolean {
	const path = pathname.split("?")[0] ?? pathname;
	if (isUserSettingsPath(path) || isLegacyUserAccountPath(path)) {
		if (path === "/user/settings" || path === "/manage/account") return true;
		const prefix = path.startsWith("/user/settings/") ? "/user/settings/" : "/manage/account/";
		const section = path.slice(prefix.length).split("/")[0] ?? "";
		return ACCOUNT_SECTIONS.has(section);
	}
	return false;
}

export function isBlockedForMailOnlyMember(pathname: string): boolean {
	if (isMailOnlyAccountPath(pathname)) return false;
	if (pathname === "/ai" || pathname.startsWith("/ai/")) return true;
	if (pathname === "/user" || pathname.startsWith("/user/")) {
		return !isMailOnlyAccountPath(pathname);
	}
	if (pathname === "/platform" || pathname.startsWith("/platform/")) return true;
	if (pathname === "/workspace" || pathname.startsWith("/workspace/")) return true;
	if (pathname === "/manage" || pathname.startsWith("/manage/")) return true;
	if (pathname === "/client" || pathname.startsWith("/client/")) return true;
	if (pathname === "/phone" || pathname.startsWith("/phone/")) return true;
	if (pathname === "/mail" || pathname.startsWith("/mail/")) return true;
	if (pathname === "/site" || pathname.startsWith("/site/")) return true;
	if (pathname === "/team" || pathname.startsWith("/team/")) return true;
	if (pathname === "/social" || pathname.startsWith("/social/")) return true;
	if (pathname === "/engage" || pathname.startsWith("/engage/")) return true;
	return false;
}
